import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import { MAX_SAFEST_INTEGER } from "../../../../utils/constants";

export const INIT_VALUE = {
  searchCriteria: {
    title: "",
    startDate: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ"),
    endDate: moment(new Date())
      .add(12, "months")
      .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ"),
    registrationtype: "",
    nominationFilter: "",
    visibility: "",
    eventType: "",
    eventMode: "",
    language: "",
    jobLevel: "",
    proficiency: "",
    location: [],
    skills: [],
    status: "",
    searchTags: {
      defaultTag: []
    }
  },
  sortCriteria: {
    sortKey: "startdate",
    order: "ASC",
    pageNo: 0,
    pageCount: MAX_SAFEST_INTEGER
  }
};

const CalendarDashboardAdminSlice = createSlice({
  name: "calendarDashboardAdmin",
  initialState: INIT_VALUE,
  reducers: {
    clearFilter(state) {
      state.searchCriteria.registrationtype =
        INIT_VALUE.searchCriteria.registrationtype;
      state.searchCriteria.nominationFilter = "";
      state.searchCriteria.visibility = INIT_VALUE.searchCriteria.visibility;
      state.searchCriteria.eventType = INIT_VALUE.searchCriteria.eventType;
      state.searchCriteria.eventMode = INIT_VALUE.searchCriteria.eventMode;
      state.searchCriteria.language = INIT_VALUE.searchCriteria.language;
      state.searchCriteria.jobLevel = INIT_VALUE.searchCriteria.jobLevel;
      state.searchCriteria.proficiency = INIT_VALUE.searchCriteria.proficiency;
      state.searchCriteria.skills = INIT_VALUE.searchCriteria.skills;
      state.searchCriteria.location = INIT_VALUE.searchCriteria.location;
      state.searchCriteria.searchTags = INIT_VALUE.searchCriteria.searchTags;
      state.searchCriteria.status = INIT_VALUE.searchCriteria.status;
    },
    setEventRegistrationType(state, action) {
      state.searchCriteria.registrationtype = action.payload;
    },
    setTitleFilter(state, action) {
      state.searchCriteria.title = action.payload;
    },
    setSkillsFilter(state, action) {
      state.searchCriteria.skills = action.payload;
    },
    setTagsFilter(state, action) {
      state.searchCriteria.searchTags.defaultTag = action.payload;
    },
    setStartDate(state, action) {
      state.searchCriteria.startDate = action.payload;
    },
    setEndDate(state, action) {
      state.searchCriteria.endDate = action.payload;
    },
    setRegistrationType(state, action) {
      state.searchCriteria.registrationtype = action.payload;
    },
    setNominationType(state, action) {
      state.searchCriteria.nominationFilter = action.payload;
    },
    setVisibility(state, action) {
      state.searchCriteria.visibility = action.payload;
    },
    setEventType(state, action) {
      state.searchCriteria.eventType = action.payload;
    },
    setEventMode(state, action) {
      state.searchCriteria.eventMode = action.payload;
    },
    setJobLevel(state, action) {
      state.searchCriteria.jobLevel = action.payload;
    },
    setProficiency(state, action) {
      state.searchCriteria.proficiency = action.payload;
    },
    setLanguage(state, action) {
      state.searchCriteria.language = action.payload;
    },
    setLocation(state, action) {
      state.searchCriteria.location = action.payload;
    },
    setStatus(state, action) {
      state.searchCriteria.status = action.payload;
    }
  }
});

export default CalendarDashboardAdminSlice;
export const CalendarDashboardAdminSliceActions =
  CalendarDashboardAdminSlice.actions;
